import { LoadState } from "../../constants/enums";

export interface ICategoryTypeState {
  list: ICategoryType[];
  loading: LoadState;
  totalRecords: number;
}

export interface ICategoryType {
  category_uuid: string | null;
  category_name: string | null;
  category_type_name: string | null;
  category_type_uuid: string | null;
  status: string;
}

export const initialCategoryTypeState: ICategoryTypeState = {
  list: [],
  loading: LoadState.NotLoaded,
  totalRecords: 0,
};

export const initialCategoryType: ICategoryType = {
  category_uuid: null,
  category_name: null,
  category_type_name: null,
  category_type_uuid: null,
  status: "ACTIVE",
};
